import CustomerKYCRepository from "@/core/customers/repositories/CustomerKYCRepository";
import type { CustomerKYCUpdateDTO } from "@/core/customers/entities/CustomerKYCUpdate";

type AdditionalInformationUpdates = Pick<
  CustomerKYCUpdateDTO,
  | "situationPatrimoniale"
  | "sourceDesFonds"
  | "objetRelationBancaire"
  | "residenceFiscalePays"
  | "ppe"
  | "fonctionPpeExercee"
  | "beneficiaireEffectif"
  | "identiteBeneficiaireEffectif"
>;

export default class UpdateAdditionalInformationUseCase {
  constructor(private readonly repository: CustomerKYCRepository) {}

  async execute(params: {
    businessKey: string;
    updates: AdditionalInformationUpdates;
  }): Promise<boolean> {
    if (Object.keys(params.updates).length === 0) {
      throw new Error("No updates provided");
    }

    return this.repository.updateAdditionalInformation(
      params.businessKey,
      params.updates,
    );
  }
}
